import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import cookie from "react-cookies";

import { moment, renderNumberGreaterThan100 } from "../../common/common";

import { getLoggedProfile } from "../../../actions/sessionAct";
import { bookCS } from "../../../model/carsubs";
import { getProfile } from "../../../model/profile";

import { commonErr } from "../../common/errors";
import { LoadingPage } from "../../common/loading";
import { formatPrice, trackOrderToAccessTrade, trackOrderToOptimise, stypes, CarTransmission } from "../../common/common";


import Login from "../../login/login";
import SignUp from "../../login/signup";

import {
	Success,
	Fail
} from "../../common/svg";


import PriceSummary from "./components/pricesummary";
import car_photo from "../../../static/images/upload/car_1.png";
import avatar_default from "../../../static/images/avatar_default.png";



class HistoryMessages extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedIndex: 0,
		};
	}

	onUpdate = () => {
		this.props.onUpdate(cookie.load("_mmessages")[this.state.selectedIndex]);
		this.props.onHide();
	};

	onHide = () => {
		this.props.onHide();
	};

	onSelectMessage = (i) => {
		this.setState({
			selectedIndex: i,
		});
	};

	render() {
		const { selectedIndex } = this.state;

		return (
			<Modal show={this.props.show} onHide={this.onHide} dialogClassName="modal-s modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Gợi ý lời nhắn</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body modal-message-history">
						{cookie.load("_mmessages") ? (
							cookie.load("_mmessages").map((message, i) => (
								<div className="custom-radio">
									<input
										type="radio"
										id={`msg_${i}`}
										name="radio"
										onChange={() => this.onSelectMessage(i)}
										checked={selectedIndex === i}
									/>
									<label htmlFor={`msg_${i}`}>{message}</label>
								</div>
							))
						) : (
							<div className="custom-radio">
								<p className="note font-12">Chưa có gợi ý lời nhắn</p>
							</div>
						)}
						<div className="wrap-btn has-2-btn">
							<a className="btn btn--m btn-primary" disabled={!cookie.load("_mmessages")} onClick={this.onUpdate}>
								Thay thế
							</a>
							<a className="btn btn-link" onClick={this.onHide}>
								Hủy
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}


const ConfirmPapers = ({ show, onHide, onBook, car }) => {
	return (
		<Modal show={show} onHide={() => onHide()} dialogClassName="modal-s modal-text">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Lưu ý</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text-body modal-document-body">
					{car.optionsTransmission === 2 ? (
						<div className="block-content textAlign-center">
							{/* <p className="body-title">Truyền động</p> */}
							<p>[+] Xe {CarTransmission[car.optionsTransmission]}</p>
							<p>Bạn cần có GPLX (B2 trở lên) và kỹ năng phù hợp.</p>
						</div>
					) : null}

					{/* {car.insSupport === 1 ? (
						<div className="block-content textAlign-center">
							<p>[+] Bảo hiểm thuê xe</p>
							<p>
								Chuyến đi của bạn được mua bảo hiểm thuê xe. Trường hợp xảy ra sự cố ngoài ý muốn, bạn chỉ phải bồi
								thường tối đa 2,000,000 VNĐ cho các thiệt hại về xe
							</p>
							
						</div>
					) : (
						<div className="block-content textAlign-center">
							<p>[+] Bảo hiểm thuê xe</p>
							<p>
								Chuyến đi của bạn không được mua bảo hiểm thuê xe. Bạn sẽ thỏa thuận trực tiếp với chủ xe trường hợp có
								xảy ra sự cố ngoài ý muốn gây thiệt hại về xe.
							</p>
						</div>
					)} */}

					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={() => onBook()}>
							Gửi yêu cầu thuê xe
						</a>
						<a className="btn btn-link" onClick={() => onHide()}>
							Hủy thuê
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

class BookingResult extends React.Component {
	render() {
		const { err, errMsg, car, trip, close, togglePopup, closePopup } = this.props;
		if (err >= commonErr.SUCCESS) {
		
				return (
					<div className="modal-confirm-body renter-confirm-body">
						<p className="font-14">
							Yêu cầu thuê xe của bạn đã được gửi thành công.
							<br /> MiCar sẽ tiếp nhận và liên hệ trong thời gian sớm nhất
						</p>
					
						<div className="wrap-btn has-2-btn">
							{/* <Link 
								// to={`/trip/detail/${trip.id}`} 
								className="btn btn--m btn-primary">
								Quản lý chuyến
							</Link> */}
							{/* {closePopup ? (
								<a
									onClick={() => {
										close();
										// togglePopup(trip.carId);
									}}
									className="btn btn--m btn-default">
									Đặt thêm xe khác
								</a>
							) : ( */}
								<a onClick={close} className="btn btn--m btn-default">
									Đóng 
								</a>
							{/* )} */}
						</div>
					</div>
				);
			// }
		} else {
			return (
				<div className="modal-confirm-body">
					<p>
						Đặt xe thất bại.
						<br />
						{errMsg}
					</p>
				</div>
			);
		}
	}
}

class BookingConfirm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isShowMoreText: false,
			showLoginForm: false,
			priceSummary: null,
			messageToOwner: "",
			showHistoryMessages: false,
			showConfirmPapers: false,
			showConfirmWD: false,
			readPolicy: true,
			showSignup: false,
			// if change placeholderMsg, change messageToOwner
			// placeholderMsg:
			// 	this.props.stype === stypes.SD
			// 		? `Gợi ý: \n\nChào anh chủ xe! \n\nTôi cần thuê xe của anh để đi du lịch cùng gia đình với thời gian như trên. \nTôi có đầy đủ giấy tờ thuê xe và tài sản thế chấp như yêu cầu. \n\nAnh vui lòng báo giúp tình trạng xe sớm nhé. Cảm ơn anh!`
			// 		: `Gợi ý: Chào anh A chủ xe.\nTôi cần đặt xe đi du lịch Vũng Tàu/Đồ Sơn cùng gia đình với thời gian như trên.\nAnh vui lòng sắp xếp báo giúp tình trạng xe sớm nhé.\nCảm ơn anh!`,
			showDetailIns: false,
		};
		// this.stype = this.props.stype;
		// this.isSD = this.props.stype === stypes.SD;

		this.heightRules = React.createRef();
	}

	componentDidMount() {
		if (this.props.uid) {
			getProfile(this.props.uid, "pd" /*view count for server*/).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					data: resp.data.data,
				});
			});
		}
	
	}

	onReadMore = () => {
		this.setState({
			isShowMoreText: true,
		});
	};

	openDetailIns = () => {
		this.setState({
			showDetailIns: true,
		});
	};

	closeDetailIns = () => {
		this.setState({
			showDetailIns: false,
		});
	};



	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	closeMessageBox = () => {
		this.setState({
			errMsg: "",
		});
	};

	closeHistoryMessages = () => {
		this.setState({
			showHistoryMessages: false,
		});
	};

	openHistoryMessages = () => {
		this.setState({
			showHistoryMessages: true,
		});
	};

	onSetMessage = (message) => {
		this.setState({
			messageToOwner: message,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	onMessageToOwnerChange = (e) => {
		this.setState({
			messageToOwner: e.target.value,
		});
	};
	onMessageFocus = () => {
		const { messageToOwner, placeholderMsg } = this.state;
		if (messageToOwner === placeholderMsg) {
			this.setState({
				messageToOwner: "",
			});
		}
	};

	onMessageBlur = () => {
		const { messageToOwner, placeholderMsg } = this.state;

		if (messageToOwner === "") {
			this.setState({
				messageToOwner: placeholderMsg,
			});
		}
	};

	// readPaperChange = (event) => {
	// 	this.setState({
	// 		readPaper: event.target.checked
	// 	});
	// }

	readPolicyChange = (event) => {
		this.setState({
			readPolicy: event.target.checked,
		});
	};

	readConfirmPapers = () => {
		this.setState({
			showConfirmPapers: true,
		});
	};

	closeConfirmPapers = () => {
		this.setState({
			showConfirmPapers: false,
		});
	};

	readConfirmWD = () => {
		this.setState({
			showConfirmWD: true,
		});
	};

	closeConfirmWD = () => {
		this.setState({
			showConfirmWD: false,
		});
	};

	isValidBooking = () => {
		// if (this.isSD) {
		// 	const car = this.props.car;
		// 	if (
		// 		(car.requiredPapers && car.requiredPapers.length === 0) ||
		// 		(car.requiredPapersOther && car.requiredPapersOther === "")
		// 	) {
		// 		return false;
		// 	}
		// }

		if (!this.state.readPolicy) {
			return false;
		}

		return true;
	};

	booking = () => {
		if (!this.props.session.profile || !this.props.session.profile.info || !this.props.session.profile.info.uid) {
			this.openLoginForm();
		} else {
			this.setState({
				err: commonErr.LOADING,
			});

			const { car, skuId, yearPicker, priceSummary } = this.props;
			const { placeholderMsg } = this.state;
			const startDate = this.props.st.valueOf();
			const endDate = this.props.et.valueOf();
	

	
			const price = JSON.stringify(priceSummary);
			
				let trip = {
					skuId: skuId, 
					dateFrom: startDate,
					dateTo: endDate, 
					yearFrom: yearPicker.yFrom,
					yearTo: yearPicker.yTo,
					price: price
				}
		
				bookCS(trip).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS) {
					
						this.props.goToResult();
					} else {
						this.props.goToError(resp.data.error, resp.data.errorMessage);
					}
				});
			

			GA
			const utmSrc = cookie.load("_utm_src") || "web_directly";
			const utmExt = cookie.load("_utm_ext") || "no_label";
			const action = "CS_BOOKING"
			
			window.gtag("event", action, {
				event_category: utmSrc,
				event_label: utmExt,
				campaign: { source: utmSrc },
			});
			window.fbq("track", action);
		}
	};

	render() {
		const {
			car,
			backToSetup,
			yearPicker,
			st, 
			et,
			priceSummary,
			timeCS
		} = this.props;
	

		if (this.state.err === commonErr.LOADING) {
			return <LoadingPage />;
		} else {
			return (
				<div className="modal-confirm-body confirm-booking">
					 <div className="overview"> 
						<h6>{car.name} ({yearPicker.yFrom === yearPicker.yTo ? yearPicker.yFrom : `${yearPicker.yFrom} - ${yearPicker.yTo}` })</h6>
						<img src={car.thumbUrl ? car.thumbUrl : car_photo} />
						<p className="fontWeight-7 font-14">Gói thuê xe: <span className="text-primary">{timeCS} tháng </span></p>
						<p className="font-14 indate">Ngày nhận xe: {moment(st).format('DD/MM/YYYY')}</p>
					</div>
					{/* <div className="car-info">
						
						<div className="car-img">
							<img loading="lazy" src={car.photos ? car.photos[0] : car_photo} alt="Mioto - Thuê xe tự lái" />
						</div>
						<div className="info-inner">
							<div className="car-desc">
								<h5 className="name">{car.name}</h5>

								<div className="content-inner">
									<p className="inner">Năm sản xuất: {yearPicker.yFrom === yearPicker.yTo ? yearPicker.yFrom : `${yearPicker.yFrom} - ${yearPicker.yTo}` }</p>
								</div>
							
							</div>
			
						</div>
					</div> */}

					{/* <div className="desc-car">
						<h6>Thời gian thuê xe: {timeCS} tháng</h6>
						<div className="rental-time">
							<div className="rental-time__item">
								<div className="wrap-svg">
									<IcCalendarBlack />
								</div>
								<div className="title">
									<p className="sub">Bắt đầu thuê xe</p>
									<h6 className="main">{moment(st).format('DD/MM/YYYY')}</h6>
								
								</div>
							</div>
							<div className="rental-time__item">
								<div className="wrap-svg">
									<IcCalendarBlack />
								</div>
								<div className="title">
									<p className="sub">Kết thúc thuê xe</p>
									<h6 className="main">{moment(et).format('DD/MM/YYYY')}</h6>
					
								</div>
							</div>
						</div>
					</div> */}
					<div className="price-main">
						<PriceSummary
							priceSummary={priceSummary}
							isSD={true}
							title={"Bảng tính giá"}
							timeCS={timeCS}
							// promo={promoCode && promoCode.code ? promoCode.code : null}
						/>
					</div>

				

					<div className="wrap-btn db-btn">
						<a className="btn btn--m btn-secondary" onClick={backToSetup}>
							Hủy
						</a>
				
					<a
						className="btn btn--m btn-primary"
						onClick={this.booking}
						// disabled={this.isValidBooking() === true ? false : true}
						>
						Gởi yêu cầu thuê xe
					</a>
					
					</div>
					<p className="last-note">
						Nhân viên MiCar sẽ liên hệ tư vấn ngay sau khi nhận được yêu cầu thuê xe của quý khách.
					</p>
					{this.state.showLoginForm && (
						<>
						{/* <Login
							show={this.state.showLoginForm}
							showModal={this.openLoginForm}
							getLoggedProfile={this.getLoggedProfile}
							hideModal={this.closeLoginForm}
						/> */}

						<Login
							show={this.state.showLoginForm}
							showModal={this.openLoginForm}
							hideModal={this.closeLoginForm}
							openSignupForm={this.openSignupForm}
							getLoggedProfile={this.getLoggedProfile}
						/>
						<SignUp
							show={this.state.showSignup}
							showModal={this.openSignupForm}
							hideModal={this.closeSignupForm}
							openLoginForm={this.openLoginForm}
							getLoggedProfile={this.getLoggedProfile}
						/>
						</>
					)}
			

				</div>
			);
		}
	}
}

class CSBooking extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			step: 1,
			trip: null,
		};
		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}


	goToResult = () => {
		this.setState({
			step: 2,
			// trip: trip,
		});
	};

	goToError = (err, errMsg) => {
		this.setState({
			step: 2,
			err: err,
			errMsg: errMsg,
		});
	};

	close = () => {
		this.setState({
			step: 1,
			err: commonErr.INNIT,
			trip: null,
		});
		this.props.hideModal();
	};

	render() {
		var content;
		var title;
		var modalClass;
		var checkImg;
		if (this.state.err === commonErr.LOADING) {
			content = (
				<section className="body">
					<LoadingPage />
				</section>
			);
		} else {
			const { err, errMsg, step, trip } = this.state;
			const {
				closePopup,
				togglePopup,
				yearPicker,
				skuId,
				car,
				st, 
				et,
				priceSummary,
				timeCS
			} = this.props;


			switch (step) {
				case 2:
					content = (
						<BookingResult
							closePopup={closePopup}
							togglePopup={togglePopup}
							err={err}
							errMsg={errMsg}
							car={car}
							close={this.close}
							// trip={trip}
						/>
					);
					title = "";
					modalClass = "modal-s modal-confirm";
					checkImg = true;
					break;
				default:
					content = (
						<BookingConfirm
							car={car}
							yearPicker={yearPicker}
							skuId={skuId}
							st={st}
							et={et}
							timeCS={timeCS}
							priceSummary={priceSummary}
							backToSetup={this.close}
							goToResult={this.goToResult}
							goToError={this.goToError}
						/>
					);
					title = "Xác nhận";
					modalClass = "modal-m modal-confirm-booking modal-confirm";
					checkImg = false;
			}
		}

		return (
			<Modal show={this.props.show} onHide={this.close} dialogClassName={`${modalClass}`}>
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>{title}</h5>
					{checkImg && (this.state.err >= commonErr.SUCCESS ? <Success /> : <Fail />)}
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}
BookingConfirm = connect(mapSessionState)(BookingConfirm);

function mapDetailState(state) {
	return {
		csDetail: state.csDetail,
	};
}
CSBooking = connect(mapDetailState)(CSBooking);

export default CSBooking;


{/* <div className="modal-content" role="document">
            <div className="modal-header">
              <button className="close close-modal" type="button"><span aria-hidden="true">×</span></button>
              <h5>Xác nhận yêu cầu</h5>
            </div>
            <div className="modal-body">
              <div className="confirm-booking"> 
                <div className="car-info">
                  <div className="car-img"><img src="https://n1-pstg-dev.mioto.vn/cho_thue_xe_o_to_tu_lai_thue_xe_du_lich_hochiminh/mazda_2_2019/p/g/2022/07/04/15/A5qRaPhjzTPH2ze_fIOtlw.jpg" alt="" /></div>
                  <div className="info-inner">
                    <div className="car-desc"> 
                      <h5 className="name">Mitsubishi Outlander 2018</h5>
                    </div>
                    <div className="content-inner">
                      <p className="inner">Năm sản xuất: 2016-2018</p>
                    </div>
                    <div className="content-inner">
                      <p className="inner">Màu xe: Màu ngẫu nhiên</p>
                    </div>
                  </div>
                </div>
                <div className="line-page" />
                <div className="desc-car"> 
                  <h6>Thời gian thuê xe: <span>2 tháng</span></h6>
                  <div className="rental-time"> 
                    <div className="rental-time__item"> 
                      <div className="wrap-svg">
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.86035 4.81V2.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M17.1396 4.81V2.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M18.05 3.7793H5.95C4.18 3.7793 2.75 5.20929 2.75 6.97929V18.0593C2.75 19.8293 4.18 21.2593 5.95 21.2593H18.06C19.83 21.2593 21.26 19.8293 21.26 18.0593V6.97929C21.25 5.20929 19.82 3.7793 18.05 3.7793Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M2.75 7.89844H21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12Z" fill="black" />
                          <path d="M14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12Z" fill="black" />
                          <path d="M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z" fill="black" />
                          <path d="M6 12C6.55228 12 7 11.5523 7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12Z" fill="black" />
                          <path d="M18 15.4902C18.5523 15.4902 19 15.0425 19 14.4902C19 13.9379 18.5523 13.4902 18 13.4902C17.4477 13.4902 17 13.9379 17 14.4902C17 15.0425 17.4477 15.4902 18 15.4902Z" fill="black" />
                          <path d="M14 15.4902C14.5523 15.4902 15 15.0425 15 14.4902C15 13.9379 14.5523 13.4902 14 13.4902C13.4477 13.4902 13 13.9379 13 14.4902C13 15.0425 13.4477 15.4902 14 15.4902Z" fill="black" />
                          <path d="M10 15.4902C10.5523 15.4902 11 15.0425 11 14.4902C11 13.9379 10.5523 13.4902 10 13.4902C9.44772 13.4902 9 13.9379 9 14.4902C9 15.0425 9.44772 15.4902 10 15.4902Z" fill="black" />
                          <path d="M6 15.4902C6.55228 15.4902 7 15.0425 7 14.4902C7 13.9379 6.55228 13.4902 6 13.4902C5.44772 13.4902 5 13.9379 5 14.4902C5 15.0425 5.44772 15.4902 6 15.4902Z" fill="black" />
                          <path d="M14 18.9707C14.5523 18.9707 15 18.523 15 17.9707C15 17.4184 14.5523 16.9707 14 16.9707C13.4477 16.9707 13 17.4184 13 17.9707C13 18.523 13.4477 18.9707 14 18.9707Z" fill="black" />
                          <path d="M10 18.9707C10.5523 18.9707 11 18.523 11 17.9707C11 17.4184 10.5523 16.9707 10 16.9707C9.44772 16.9707 9 17.4184 9 17.9707C9 18.523 9.44772 18.9707 10 18.9707Z" fill="black" />
                          <path d="M6 18.9707C6.55228 18.9707 7 18.523 7 17.9707C7 17.4184 6.55228 16.9707 6 16.9707C5.44772 16.9707 5 17.4184 5 17.9707C5 18.523 5.44772 18.9707 6 18.9707Z" fill="black" />
                        </svg>
                      </div>
                      <div className="title"> 
                        <p className="sub">Bắt đầu thuê xe</p>
                        <h6 className="main">09/08/2023</h6>
                      </div>
                    </div>
                    <div className="rental-time__item"> 
                      <div className="wrap-svg">
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.86035 4.81V2.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M17.1396 4.81V2.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M18.05 3.7793H5.95C4.18 3.7793 2.75 5.20929 2.75 6.97929V18.0593C2.75 19.8293 4.18 21.2593 5.95 21.2593H18.06C19.83 21.2593 21.26 19.8293 21.26 18.0593V6.97929C21.25 5.20929 19.82 3.7793 18.05 3.7793Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M2.75 7.89844H21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12Z" fill="black" />
                          <path d="M14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12Z" fill="black" />
                          <path d="M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z" fill="black" />
                          <path d="M6 12C6.55228 12 7 11.5523 7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12Z" fill="black" />
                          <path d="M18 15.4902C18.5523 15.4902 19 15.0425 19 14.4902C19 13.9379 18.5523 13.4902 18 13.4902C17.4477 13.4902 17 13.9379 17 14.4902C17 15.0425 17.4477 15.4902 18 15.4902Z" fill="black" />
                          <path d="M14 15.4902C14.5523 15.4902 15 15.0425 15 14.4902C15 13.9379 14.5523 13.4902 14 13.4902C13.4477 13.4902 13 13.9379 13 14.4902C13 15.0425 13.4477 15.4902 14 15.4902Z" fill="black" />
                          <path d="M10 15.4902C10.5523 15.4902 11 15.0425 11 14.4902C11 13.9379 10.5523 13.4902 10 13.4902C9.44772 13.4902 9 13.9379 9 14.4902C9 15.0425 9.44772 15.4902 10 15.4902Z" fill="black" />
                          <path d="M6 15.4902C6.55228 15.4902 7 15.0425 7 14.4902C7 13.9379 6.55228 13.4902 6 13.4902C5.44772 13.4902 5 13.9379 5 14.4902C5 15.0425 5.44772 15.4902 6 15.4902Z" fill="black" />
                          <path d="M14 18.9707C14.5523 18.9707 15 18.523 15 17.9707C15 17.4184 14.5523 16.9707 14 16.9707C13.4477 16.9707 13 17.4184 13 17.9707C13 18.523 13.4477 18.9707 14 18.9707Z" fill="black" />
                          <path d="M10 18.9707C10.5523 18.9707 11 18.523 11 17.9707C11 17.4184 10.5523 16.9707 10 16.9707C9.44772 16.9707 9 17.4184 9 17.9707C9 18.523 9.44772 18.9707 10 18.9707Z" fill="black" />
                          <path d="M6 18.9707C6.55228 18.9707 7 18.523 7 17.9707C7 17.4184 6.55228 16.9707 6 16.9707C5.44772 16.9707 5 17.4184 5 17.9707C5 18.523 5.44772 18.9707 6 18.9707Z" fill="black" />
                        </svg>
                      </div>
                      <div className="title"> 
                        <p className="sub">Kết thúc thuê xe</p>
                        <h6 className="main">09/10/2023</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="price-container">
                  <h6>Bảng tính giá</h6>
                  <div className="price-item"> 
                    <p className="df-align-center">Đơn giá thuê</p>
                    <p className="cost">8.500.000đ&nbsp;/&nbsp;tháng</p>
                  </div>
                  <div className="price-item discount"> 
                    <p className="df-align-center">Giảm giá</p>
                    <p className="cost">-20%&nbsp;/&nbsp;đơn hàng</p>
                  </div>
                  <div className="line-page" />
                  <div className="price-item"> 
                    <p>Tổng thời gian thuê</p>
                    <p className="cost">1 tháng</p>
                  </div>
                  <div className="price-item"> 
                    <p>Khuyến mãi</p>
                    <p className="cost">-100.000đ</p>
                  </div>
                  <div className="line-page"> </div>
                  <div className="price-item total">
                    <p>Tổng cộng</p>
                    <p className="cost">8.500.000đ</p>
                  </div>
                  <div className="line-page"> </div>
                  <div className="price-item deposit">
                    <p>Tiền cọc</p>
                    <p className="cost">500.000đ</p>
                  </div>
                  <div className="price-item deposit">
                    <p>Thanh toán khi nhận xe</p>
                    <p className="cost">8.500.000đ</p>
                  </div>
                </div>
                <div className="wrap-text">
                  <div className="custom-checkbox-selected">
                    <input type="checkbox" id="checkbox" name="checkbox" />
                    <label htmlFor="checkbox">Tôi đã hiểu và đồng ý với<span>&nbsp;chính sách&nbsp; </span>điều khoản của MiCar.</label>
                  </div><a className="detail">Chi tiết</a>
                </div>
                <div className="wrap-btn db-btn"> <a className="btn btn--m btn-secondary">Hủy</a><a className="btn btn--m btn-primary">Xác nhận </a></div>
                <p className="last-note">(*Trường hợp nhiều khách đặt xe cùng một thời điểm, hệ thống sẽ ưu tiên khách hàng thanh toán sớm nhất)</p>
              </div>
            </div>
          </div> */}